import {REQUEST_RULES} from "@actions/actionTypes";

export function getRules() {
    return dispatch => {
        dispatch({type: REQUEST_RULES});
    }
}